import React, {useEffect, useState, useContext} from "react";
import StudentDiagnosticReport from "./StudentDiagnosticReport";
import axios from "../common/axios";
import PagedList from "../common/PagedList";
import {UserContext} from "../common/UserContext";
import Tabs from "../common/Tabs";
import Tab from "../common/Tab";
import Button from "../common/Button";
import {BrandContext} from "../common/BrandContext";
import {Pending, Visibility, VisibilityOff} from "@mui/icons-material";
import TableAntD from "../common/TableAntD";

const StudentDiagnosticReports = props => {
    const brandConfig = useContext(BrandContext);
    const [testResultId, setTestResultId] = useState();
    const [loading, setLoading] = useState(true);
    const [viewed, setViewed] = useState(false);
    const [resultsTableData, setResultsTableData] = useState([]);
    const userContext = useContext(UserContext).user;
    const {user, updateFollowUpWork} = useContext(UserContext);
    const emptyText= 'You have no follow-up work';
    const resultsTableColumns = [
        {
            title: 'Teacher',
            dataIndex: 'teacher',
        },
        {
            title: 'Test',
            dataIndex: 'test',
        },
        {
            title: 'Date',
            dataIndex: 'date',
        },
        {
            title: 'Due',
            dataIndex: 'due',
        },
        {
            title: brandConfig.diagnosticFeedbackName,
            dataIndex: 'details1',
            colSpan: 2,
            width: 100,
            align: 'left'
        },
        {
            title: brandConfig.diagnosticFeedbackName,
            colSpan: 0,
            dataIndex: 'details2',
            width: 100
        },
    ]

    const handleViewFeedback = testResultId => {
        window.location.hash = testResultId;
        axios.post('/web/ui/test/updateStudentDiagnosticTestFeedbackViewed', null, {params: {testResultId: testResultId}})
    }

    const handleChange = key => {
        setViewed(key !== '0');
    };

    useEffect(() => {
        const handleHashChange = (event) => {
            const hash = window.location.hash.slice(1);
            const hashNumericValue = Number(hash);
            if (!isNaN(hashNumericValue) && typeof hashNumericValue === 'number') {
                setTestResultId(hashNumericValue);
            } else {
                setTestResultId(null);
            }
        };
        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    useEffect(() => {
        if (!testResultId) {
            axios.get('/web/ui/test/getStudentDiagnosticTestResults', {params: {feedbackComplete: viewed}})
                .then(response => {
                    let newTableData = [];
                    response.data.map((result, index) => {
                        newTableData.push({
                            key: index,
                            teacher: result.teacherName,
                            test: <b>{result.testName}</b>,
                            date: result.feedbackAssignedDate ? userContext.dateTimeFormat.format(new Date(result.feedbackAssignedDate)) : 'N/A',
                            due: result.feedbackDueDate ? userContext.dateTimeFormat.format(new Date(result.feedbackDueDate)) : 'N/A',
                            details1: (
                                <Button className="" type={user.testResultId === result.testResultId ? "outline" : "text"} onClick={() => updateFollowUpWork(result.testResultId)}>
                                    {result.skillResourceCount} skills to revise</Button>
                            ),
                            details2: (
                                <Button className=""
                                        onClick={() => handleViewFeedback(result.testResultId)}>View
                                    feedback</Button>
                            ),
                        })
                    });
                    setResultsTableData(newTableData);
                    setLoading(false);
                });
        }
    }, [viewed, testResultId, user]);

    if (testResultId && testResultId > 0) {
        return (
            <StudentDiagnosticReport testResultId={testResultId} emptyText={emptyText} handleFollowUpWork={updateFollowUpWork} />
        )
    } else {
        return (
            <>
                <Tabs defaultActiveKey={viewed ? '1' : '0'} onChange={handleChange} variant="standard" destroyOnHidden={true}>
                    <Tab hash={'unviewed'} key={0}
                         children={
                             <div className="padding-t--l">
                                 <h2 className="margin-b--l">{brandConfig.diagnosticFeedbackName}</h2>
                                 <TableAntD dynamicWidth={true} columnData={resultsTableColumns}
                                            dataSource={resultsTableData} noDataMessage={emptyText} loading={loading}/>
                             </div>
                         }
                         tab={
                             <>
                                 <VisibilityOff className={'margin-r--m'} fontSize={'small'}/>
                                 <span className={'margin-r--m tabText'}>Unviewed</span>
                             </>
                         }
                    />
                    <Tab hash={'viewed'} key={1}
                        children={
                            <div className="padding-t--l">
                                <h2 className="margin-b--l">{brandConfig.diagnosticFeedbackName}</h2>
                                <TableAntD dynamicWidth={true} columnData={resultsTableColumns}
                                           dataSource={resultsTableData} noDataMessage={emptyText} loading={loading}/>
                            </div>
                        }
                         tab={
                             <><Visibility className={'margin-r--m'} fontSize={'small'}/><span
                                 className={'margin-r--m tabText'}>Viewed</span></>
                         }
                    />
                </Tabs>
            </>
        )
    }
}

export default StudentDiagnosticReports;